import { render, staticRenderFns } from "./ItemSmallList.vue?vue&type=template&id=08730244&"
import script from "./ItemSmallList.vue?vue&type=script&lang=js&"
export * from "./ItemSmallList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports